var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-step-component"},[_c('menu-items-list',{attrs:{"items":_vm.computedMenuItems,"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"before-menu-items",fn:function(){return [_c('food-categories')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }